import _ from "underscore";
import Marionette from "marionette";
import "plugins/password";
import "css!apps/UserProfile/view/css/UserProfileView";
import template from "apps/UserProfile/view/template/UserProfileView.html";

let error404images = {};
export default Marionette.ItemView.extend("UserProfileView", {
    template,

    modelEvents: {
        change: "onChange"
    },

    ui: {
        $phone1: ".UserProfileView--phone1",
        $phone2: ".UserProfileView--phone2",
        $email: ".UserProfileView--email",
        $passBlock: ".UserProfileView--passBlock",
        $password: ".UserProfileView--password",
        $passwordRepeat: ".UserProfileView--passwordRepeat",
        $savePass: ".UserProfileView--savePass",
        $img: ".UserProfileView--img",
        $imgInput: ".UserProfileView--imgInput",
        $taskNotifiesCheckboxes: ".UserProfileView--taskNotify",
        $notifySettings: ".UserProfileView--notifySettings",
        $lang: ".UserProfileView--lang"
    },

    events: {
        "keyup @ui.$phone1": "onKeyupPhone",
        "keyup @ui.$phone2": "onKeyupPhone",
        "keyup @ui.$email": "onKeyupEmail",
        "input @ui.$password": "onInputPassword",
        "input @ui.$passwordRepeat": "onInputPassword",
        "keyup @ui.$passwordRepeat": "onKeyupPasswordRepeat",
        "click @ui.$savePass": "onClickSavePass",
        "change @ui.$imgInput": "onChangeImgInput",
        "click @ui.$taskNotifiesCheckboxes": "onNotifyTaskChange",
        "click @ui.$notifySettings": "onClickNotifySettings",
        "change @ui.$lang": "onChangeLang"
    },

    initialize() {
        this._waitUpdate = 0;

        this.onKeyupPhone = _.debounce(this.onKeyupPhone.bind(this), 1000);
        this.onKeyupEmail = _.debounce(this.onKeyupEmail.bind(this), 1000);
    },

    className() {
        let className = "UserProfileView theme-background-color";
        if ( this.model.get("IS_ONLINE") ) {
            className += " isOnline";
        }
        return className;
    },

    attributes() {
        return {
            "color-index": this.model.get("COLOR_INDEX")
        };
    },

    show() {
        this.$el.focusManager("focus");
        this.$el.addClass("showed");

        if ( !this.loadedPhonePlugin ) {
            this.loadedPhonePlugin = true;
            require(["intlTelInput"], () => {
                this.ui.$phone1.intlTelInput({
                    markup: false,
                    defaultCountry: "ru"
                });
                this.ui.$phone2.intlTelInput({
                    markup: false,
                    defaultCountry: "ru"
                });
            });
        }
    },

    hide() {
        this.$el.focusManager("blur");
        this.$el.removeClass("showed");
    },

    onRender() {
        this.ui.$passBlock.focusManager({
            onFocus: this.onFocusPassBlock.bind(this),
            onBlur: this.onBlurPassBlock.bind(this)
        });

        this.ui.$password.password();
        this.ui.$passwordRepeat.password();
        this.ui.$savePass.addClass("disabled");
        // user avatar
        let image = this.ui.$img.find("img")[0];
        let src = image && image.src;

        if ( !image ) {
            return;
        }

        let loaded = false;
        if ( error404images[src] ) {
            image.parentNode.classList.remove("loading");
            image.parentNode.classList.add("noImage");
            image.parentNode.style.backgroundImage = "";
            image.removeAttribute("src");
            loaded = true;
        } else {
            image.addEventListener("load", function() {
                image.parentNode.classList.remove("loading");
                loaded = true;
            });
            image.addEventListener("error", function() {
                image.parentNode.classList.remove("loading");
                image.parentNode.classList.add("noImage");
                loaded = true;
                error404images[image.src] = true;
            });
        }

        if ( loaded ) {
            return;
        }

        setTimeout(function() {
            if ( !loaded ) {
                image.parentNode.classList.add("loading");
            }
        }, 50);
    },

    onFocusPassBlock() {
        this.$el.addClass("focusPass");
    },

    onBlurPassBlock() {
        this.$el.removeClass("focusPass");
    },

    onChange() {
        if ( this._waitUpdate ) {
            return;
        }
        this.render();
    },

    waitUpdate() {
        this._waitUpdate++;
    },

    unwaitUpdate() {
        this._waitUpdate--;
        this._waitUpdate = Math.max(this._waitUpdate, 0);
    },

    onKeyupPhone() {
        this.trigger("enter:phone1", this.ui.$phone1.val());
        this.trigger("enter:phone2", this.ui.$phone2.val());
    },

    onKeyupEmail() {
        this.trigger("enter:email", this.ui.$email.val());
    },

    onInputPassword() {
        let password = this.ui.$password.val();
        let passwordRepeat = this.ui.$passwordRepeat.val();

        if ( password && password.length < 6 ) {
            this.ui.$password.addClass("error");
        } else {
            this.ui.$password.removeClass("error");
        }
        if ( passwordRepeat && password !== passwordRepeat ) {
            this.ui.$passwordRepeat.addClass("error");
        } else {
            this.ui.$passwordRepeat.removeClass("error");
        }

        if ( password && password.length >= 6 && password === passwordRepeat ) {
            this.ui.$savePass.removeClass("disabled");
        } else {
            this.ui.$savePass.addClass("disabled");
        }
    },

    onKeyupPasswordRepeat(e) {
        if ( e.keyCode == 13 ) {
            return this.onClickSavePass(e);
        }
    },

    onClickSavePass() {
        let password = this.ui.$password.val();
        let passwordRepeat = this.ui.$passwordRepeat.val();

        if ( password && password.length >= 6 && password === passwordRepeat ) {
            this.ui.$password.val("").removeClass("error");
            this.ui.$passwordRepeat.val("").removeClass("error");
            this.ui.$savePass.addClass("disabled");
            this.trigger("savePassword", password);
        }
    },

    onChangeImgInput(e) {
        e.preventDefault();
        let files = this.ui.$imgInput.prop("files");
        this.trigger("enter:image", files[0]);
    },

    onNotifyTaskChange(e) {
        let checked = e.currentTarget.checked;
        let key = e.currentTarget.getAttribute("key");

        this.trigger("changed:notifyOption", { key, checked });
        this.render();
    },

    onClickNotifySettings() {
        system.runApp({
            type: "Form2",
            table: "LIST_USER",
            id: system.user.id,
            name: "UserForm",
            activeTab: "email_settings"
        });
        system.apps.channel("UserProfile").trigger("hide");
        system.apps.channel("Menu").trigger("hide");
    },

    onChangeLang() {
        let langId = this.ui.$lang.val();
        this.trigger("changed:lang", langId);
    }
});
